// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendorCardStyle_vendorCardGrid__uB3qK,
.vendorCardStyle_vendorCardList__9Ifdt {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  border-radius: var(--border-radius-large);
  overflow: hidden;
  border: 1px solid var(--border);
  transition: all 0.2s ease-in-out;
  height: 100%;
  cursor: pointer;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardImg__AZWJR,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR {
  height: 200px;
  position: relative;
  max-width: 150px;
  min-width: 150px;
  width: 100%;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardImg__AZWJR img,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardImg__AZWJR .vendorCardStyle_topLabel__JkweY,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR .vendorCardStyle_topLabel__JkweY {
  position: absolute;
  top: 15px;
  left: 0;
  background-color: rgba(156, 56, 189, 0.8470588235);
  color: var(--white);
  font: var(--body-font-four);
  font-weight: 500;
  padding: 8px 10px;
  z-index: 1;
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 0 50px 50px 0;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardImg__AZWJR .vendorCardStyle_topLabel__JkweY img,
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardImg__AZWJR .vendorCardStyle_topLabel__JkweY svg,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR .vendorCardStyle_topLabel__JkweY img,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR .vendorCardStyle_topLabel__JkweY svg {
  width: 18px;
  display: block;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardImg__AZWJR .vendorCardStyle_partialLabel__PdhJY,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR .vendorCardStyle_partialLabel__PdhJY {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(240, 173, 78, 0.9);
  color: var(--white);
  font: var(--body-font-four);
  font-weight: 500;
  padding: 6px 10px;
  z-index: 1;
  text-align: center;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER {
  padding: 12px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK {
  margin-bottom: 12px;
  width: 100%;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  margin-bottom: 4px;
  flex-wrap: wrap;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp h4,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp h4 {
  font: var(--body-font-four);
  font-weight: 500;
  color: var(--secondary-Text);
  text-transform: capitalize;
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp h4 .vendorCardStyle_typeChip__OC-jZ,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp h4 .vendorCardStyle_typeChip__OC-jZ {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  max-width: 120px;
  flex-wrap: wrap;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp h4 .vendorCardStyle_moreTypesChip__EYdvF,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp h4 .vendorCardStyle_moreTypesChip__EYdvF {
  font: var(--body-font-four);
  font-weight: 500;
  color: var(--secondary-Text);
  text-transform: lowercase;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp .vendorCardStyle_rating__h7NYJ,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp .vendorCardStyle_rating__h7NYJ {
  display: flex;
  align-items: center;
  gap: 2px;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp .vendorCardStyle_rating__h7NYJ li,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp .vendorCardStyle_rating__h7NYJ li {
  width: 12px;
  height: 12px;
  display: flex;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp .vendorCardStyle_rating__h7NYJ li img,
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp .vendorCardStyle_rating__h7NYJ li svg,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp .vendorCardStyle_rating__h7NYJ li img,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_review__aOAlp .vendorCardStyle_rating__h7NYJ li svg {
  width: 100%;
  height: 100%;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_vendorName__Di8DM,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_nameAndReview__MAruK .vendorCardStyle_vendorName__Di8DM {
  font: var(--body-font-two);
  color: var(--primary-Text);
  text-transform: capitalize;
  font-weight: 600;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_location__IV\\+Cu,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_location__IV\\+Cu {
  display: flex;
  gap: 5px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
  margin-top: auto;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_location__IV\\+Cu img,
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_location__IV\\+Cu svg,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_location__IV\\+Cu img,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_location__IV\\+Cu svg {
  width: 16px;
  height: 16px;
  display: block;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardDetails__53IER .vendorCardStyle_location__IV\\+Cu span,
.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER .vendorCardStyle_location__IV\\+Cu span {
  color: var(--secondary-Text);
  font: var(--body-font-four);
  display: block;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vendorCardStyle_vendorCardGrid__uB3qK.vendorCardStyle_vendorCardList__9Ifdt,
.vendorCardStyle_vendorCardList__9Ifdt.vendorCardStyle_vendorCardList__9Ifdt {
  flex-direction: row;
}
.vendorCardStyle_vendorCardGrid__uB3qK.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_card__P2DII,
.vendorCardStyle_vendorCardList__9Ifdt.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_card__P2DII {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.vendorCardStyle_vendorCardGrid__uB3qK.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR,
.vendorCardStyle_vendorCardList__9Ifdt.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR {
  height: 113px;
}
.vendorCardStyle_vendorCardGrid__uB3qK.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR .vendorCardStyle_topLabel__JkweY,
.vendorCardStyle_vendorCardList__9Ifdt.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR .vendorCardStyle_topLabel__JkweY {
  top: 8px;
}
.vendorCardStyle_vendorCardGrid__uB3qK.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER,
.vendorCardStyle_vendorCardList__9Ifdt.vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardDetails__53IER {
  padding: 12px 16px 12px 12px;
  flex: 1 1;
}
.vendorCardStyle_vendorCardGrid__uB3qK:hover,
.vendorCardStyle_vendorCardList__9Ifdt:hover {
  background-color: #faf4f2;
}
.vendorCardStyle_vendorCardGrid__uB3qK.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardImg__AZWJR,
.vendorCardStyle_vendorCardList__9Ifdt.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardImg__AZWJR {
  max-width: 100%;
  min-width: 100%;
}

.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_card__P2DII {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_review__aOAlp h4 .vendorCardStyle_typeChip__OC-jZ {
  max-width: 90px !important;
}

@media (max-width: 1200px) {
  .vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR {
    height: 100% !important;
    aspect-ratio: 3/2;
  }
}
@media (max-width: 767px) {
  .vendorCardStyle_vendorCardGrid__uB3qK .vendorCardStyle_cardImg__AZWJR,
  .vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_cardImg__AZWJR {
    height: 160px !important;
    max-width: 100%;
    min-width: 100%;
  }
}
@media (max-width: 575px) {
  .vendorCardStyle_vendorCardList__9Ifdt .vendorCardStyle_card__P2DII {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/vendor-card/vendorCardStyle.module.scss"],"names":[],"mappings":"AAAA;;EAEC,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;EACA,yCAAA;EACA,gBAAA;EACA,+BAAA;EACA,gCAAA;EACA,YAAA;EACA,eAAA;AACD;AACC;;EACC,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAEF;AAAE;;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;AAGH;AAAE;;EACC,kBAAA;EACA,SAAA;EACA,OAAA;EACA,kDAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,4BAAA;AAGH;AADG;;;;EAEC,WAAA;EACA,cAAA;AAKJ;AADE;;EACC,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,yCAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;AAIH;AAAC;;EACC,aAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AAGF;AADE;;EACC,mBAAA;EACA,WAAA;AAIH;AAFG;;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;AAKJ;AAHI;;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAML;AAJK;;EACC,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;AAON;AAJK;;EACC,2BAAA;EACA,gBAAA;EACA,4BAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAON;AAHI;;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAML;AAJK;;EACC,WAAA;EACA,YAAA;EACA,aAAA;AAON;AALM;;;;EAEC,WAAA;EACA,YAAA;AASP;AAHG;;EACC,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,gBAAA;AAMJ;AAFE;;EACC,aAAA;EACA,QAAA;EACA,iBAAA;EACA,mCAAA;EACA,gBAAA;AAKH;AAHG;;;;EAEC,WAAA;EACA,YAAA;EACA,cAAA;AAOJ;AAJG;;EACC,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AAOJ;AAAC;;EACC,mBAAA;AAGF;AADE;;EACC,aAAA;EACA,eAAA;EACA,WAAA;AAIH;AADE;;EACC,aAAA;AAIH;AAFG;;EACC,QAAA;AAKJ;AADE;;EACC,4BAAA;EACA,SAAA;AAIH;AAAC;;EACC,yBAAA;AAGF;AACE;;EACC,eAAA;EACA,eAAA;AAEH;;AAKC;EACC,YAAA;EACA,aAAA;EACA,sBAAA;AAFF;AAOG;EACC,0BAAA;AALJ;;AAWA;EAEE;IACC,uBAAA;IACA,iBAAA;EATD;AACF;AAaA;EAIE;;IACC,wBAAA;IACA,eAAA;IACA,eAAA;EAbD;AACF;AAiBA;EAEE;IACC,sBAAA;EAhBD;AACF","sourcesContent":[".vendorCardGrid,\r\n.vendorCardList {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: space-between;\r\n\tgap: 12px;\r\n\tborder-radius: var(--border-radius-large);\r\n\toverflow: hidden;\r\n\tborder: 1px solid var(--border);\r\n\ttransition: all 0.2s ease-in-out;\r\n\theight: 100%;\r\n\tcursor: pointer;\r\n\r\n\t.cardImg {\r\n\t\theight: 200px;\r\n\t\tposition: relative;\r\n\t\tmax-width: 150px;\r\n\t\tmin-width: 150px;\r\n\t\twidth: 100%;\r\n\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tobject-fit: cover;\r\n\t\t\tobject-position: center;\r\n\t\t}\r\n\r\n\t\t.topLabel {\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 15px;\r\n\t\t\tleft: 0;\r\n\t\t\tbackground-color: #9c38bdd8;\r\n\t\t\tcolor: var(--white);\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tpadding: 8px 10px;\r\n\t\t\tz-index: 1;\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 5px;\r\n\t\t\tborder-radius: 0 50px 50px 0;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 18px;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.partialLabel {\r\n\t\t\tposition: absolute;\r\n\t\t\tbottom: 0;\r\n\t\t\tleft: 0;\r\n\t\t\tright: 0;\r\n\t\t\tbackground-color: rgba(240, 173, 78, 0.9);\r\n\t\t\tcolor: var(--white);\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t\tfont-weight: 500;\r\n\t\t\tpadding: 6px 10px;\r\n\t\t\tz-index: 1;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\t}\r\n\r\n\t.cardDetails {\r\n\t\tpadding: 12px;\r\n\t\tflex: 1;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\r\n\t\t.nameAndReview {\r\n\t\t\tmargin-bottom: 12px;\r\n\t\t\twidth: 100%;\r\n\r\n\t\t\t.review {\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: space-between;\r\n\t\t\t\tgap: 5px;\r\n\t\t\t\tmargin-bottom: 4px;\r\n\t\t\t\tflex-wrap: wrap;\r\n\r\n\t\t\t\th4 {\r\n\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\ttext-transform: capitalize;\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 5px;\r\n\t\t\t\t\tflex-wrap: wrap;\r\n\r\n\t\t\t\t\t.typeChip {\r\n\t\t\t\t\t\toverflow: hidden;\r\n\t\t\t\t\t\ttext-overflow: ellipsis;\r\n\t\t\t\t\t\twhite-space: nowrap;\r\n\t\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\t\tmax-width: 120px;\r\n\t\t\t\t\t\tflex-wrap: wrap;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t.moreTypesChip {\r\n\t\t\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\t\t\ttext-transform: lowercase;\r\n\t\t\t\t\t\tmax-width: 90px;\r\n\t\t\t\t\t\toverflow: hidden;\r\n\t\t\t\t\t\ttext-overflow: ellipsis;\r\n\t\t\t\t\t\twhite-space: nowrap;\r\n\t\t\t\t\t\tdisplay: block;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\r\n\t\t\t\t.rating {\r\n\t\t\t\t\tdisplay: flex;\r\n\t\t\t\t\talign-items: center;\r\n\t\t\t\t\tgap: 2px;\r\n\r\n\t\t\t\t\tli {\r\n\t\t\t\t\t\twidth: 12px;\r\n\t\t\t\t\t\theight: 12px;\r\n\t\t\t\t\t\tdisplay: flex;\r\n\r\n\t\t\t\t\t\timg,\r\n\t\t\t\t\t\tsvg {\r\n\t\t\t\t\t\t\twidth: 100%;\r\n\t\t\t\t\t\t\theight: 100%;\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.vendorName {\r\n\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\ttext-transform: capitalize;\r\n\t\t\t\tfont-weight: 600;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.location {\r\n\t\t\tdisplay: flex;\r\n\t\t\tgap: 5px;\r\n\t\t\tpadding-top: 12px;\r\n\t\t\tborder-top: 1px solid var(--border);\r\n\t\t\tmargin-top: auto;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tcolor: var(--secondary-Text);\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t\tdisplay: -webkit-box;\r\n\t\t\t\tmax-width: 100%;\r\n\t\t\t\t-webkit-line-clamp: 1;\r\n\t\t\t\t-webkit-box-orient: vertical;\r\n\t\t\t\toverflow: hidden;\r\n\t\t\t\ttext-overflow: ellipsis;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t// ==== list design ====\r\n\r\n\t&.vendorCardList {\r\n\t\tflex-direction: row;\r\n\r\n\t\t.card {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-wrap: wrap;\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t.cardImg {\r\n\t\t\theight: 113px;\r\n\r\n\t\t\t.topLabel {\r\n\t\t\t\ttop: 8px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.cardDetails {\r\n\t\t\tpadding: 12px 16px 12px 12px;\r\n\t\t\tflex: 1;\r\n\t\t}\r\n\t}\r\n\r\n\t&:hover {\r\n\t\tbackground-color: #faf4f2;\r\n\t}\r\n\r\n\t&.vendorCardGrid {\r\n\t\t.cardImg {\r\n\t\t\tmax-width: 100%;\r\n\t\t\tmin-width: 100%;\r\n\t\t}\r\n\r\n\t}\r\n}\r\n\r\n.vendorCardGrid {\r\n\t.card {\r\n\t\theight: 100%;\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t}\r\n\r\n\t.review {\r\n\t\th4 {\r\n\t\t\t.typeChip {\r\n\t\t\t\tmax-width: 90px !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n\t.vendorCardList {\r\n\t\t.cardImg {\r\n\t\t\theight: 100% !important;\r\n\t\t\taspect-ratio: 3 / 2;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\r\n\t.vendorCardGrid,\r\n\t.vendorCardList {\r\n\t\t.cardImg {\r\n\t\t\theight: 160px !important;\r\n\t\t\tmax-width: 100%;\r\n\t\t\tmin-width: 100%;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@media (max-width: 575px) {\r\n\t.vendorCardList {\r\n\t\t.card {\r\n\t\t\tflex-direction: column;\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"vendorCardGrid": `vendorCardStyle_vendorCardGrid__uB3qK`,
	"vendorCardList": `vendorCardStyle_vendorCardList__9Ifdt`,
	"cardImg": `vendorCardStyle_cardImg__AZWJR`,
	"topLabel": `vendorCardStyle_topLabel__JkweY`,
	"partialLabel": `vendorCardStyle_partialLabel__PdhJY`,
	"cardDetails": `vendorCardStyle_cardDetails__53IER`,
	"nameAndReview": `vendorCardStyle_nameAndReview__MAruK`,
	"review": `vendorCardStyle_review__aOAlp`,
	"typeChip": `vendorCardStyle_typeChip__OC-jZ`,
	"moreTypesChip": `vendorCardStyle_moreTypesChip__EYdvF`,
	"rating": `vendorCardStyle_rating__h7NYJ`,
	"vendorName": `vendorCardStyle_vendorName__Di8DM`,
	"location": `vendorCardStyle_location__IV+Cu`,
	"card": `vendorCardStyle_card__P2DII`
};
export default ___CSS_LOADER_EXPORT___;
